import React from 'react';
import { IoCalendarClearOutline } from "react-icons/io5";

function DatePickerField({id, label, placeholder, value, onChange, error, validation, isReadOnly}) {
  return (
<div className="mb-3" >
  <label htmlFor="dob" className="form-label">
    {label}
  </label>
  <div style={{ position: "relative" }}>
  <input
    className="form-control no-spinner"
    type="date"
    id={id}
    onChange={onChange}
    value={value}
    readOnly={isReadOnly}
    style={{
      backgroundColor: isReadOnly ? '#F5F5F5' : '',
      paddingRight: '40px' // leave space for icon
    }}
  />
  {/* Calendar icon */}
  <IoCalendarClearOutline
    style={{
      position: "absolute",
      top: "55%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "#999"
    }}
    className='calendar-icon'
  />
  </div>
  {error && (
    <>
      <small className="error-text">{error}</small>
      <br />
    </>
  )}
  {validation && (
    <>
      <small className="validation-text">{validation}</small>
      <br />
    </>
  )}
</div>
  )
}

export default DatePickerField;